export const FETCH_CREDIT_TYPES_REQUEST = 'FETCH_CREDIT_TYPES_REQUEST';
export const FETCH_CREDIT_TYPES_SUCCESS = 'FETCH_CREDIT_TYPES_SUCCESS';
export const FETCH_CREDIT_TYPES_FAILED = 'FETCH_CREDIT_TYPES_FAILED';

export const FETCH_CREDIT_TYPE_BY_ID_REQUEST = 'FETCH_CREDIT_TYPE_BY_ID_REQUEST';
export const FETCH_CREDIT_TYPE_BY_ID_SUCCESS = 'FETCH_CREDIT_TYPE_BY_ID_SUCCESS';
export const FETCH_CREDIT_TYPE_BY_ID_FAILED = 'FETCH_CREDIT_TYPE_BY_ID_FAILED';

export const CREATE_CREDIT_TYPE_REQUEST = 'CREATE_CREDIT_TYPE_REQUEST';
export const CREATE_CREDIT_TYPE_SUCCESS = 'CREATE_CREDIT_TYPE_SUCCESS';
export const CREATE_CREDIT_TYPE_FAILED = 'CREATE_CREDIT_TYPE_FAILED';

export const RESET_CREDIT_TYPE = 'RESET_CREDIT_TYPE';

export const DELETE_CREDIT_TYPE_REQUEST = 'DELETE_CREDIT_TYPE_REQUEST';
export const DELETE_CREDIT_TYPE_SUCCESS = 'DELETE_CREDIT_TYPE_SUCCESS';
export const DELETE_CREDIT_TYPE_FAILED = 'DELETE_CREDIT_TYPE_FAILED';

export const UPDATE_CREDIT_TYPE_REQUEST = 'UPDATE_CREDIT_TYPE_REQUEST';
export const UPDATE_CREDIT_TYPE_SUCCESS = 'UPDATE_CREDIT_TYPE_SUCCESS';
export const UPDATE_CREDIT_TYPE_FAILED = 'UPDATE_CREDIT_TYPE_FAILED';
export const UPDATE_CREDIT_TYPE_RESET = 'UPDATE_CREDIT_TYPE_RESET';
